import {getErrorMessage, noop} from '@logistics-frontend/utils'
import clsx from 'clsx'
import {useCallback, useState} from 'react'

import {classes} from './classes'
import {NotificationsProvider} from './context'
import {Notification} from './Notification'
import {AddNotification, CustomNotification} from './types'

let id = 0

export const Notifications: React.FC<
  React.PropsWithChildren<{className?: string; isNotificationsDisabled?: boolean}>
> = ({children, className, isNotificationsDisabled}) => {
  const [notifications, setNotifications] = useState<CustomNotification[]>([])

  const removeNotification = useCallback((itemId: CustomNotification['id']) => {
    setNotifications(list => list.filter(({id}) => id !== itemId))
  }, [])

  const addNotification = useCallback<AddNotification>((msg, notificationConfig) => {
    const message = msg instanceof Error ? getErrorMessage(msg) : msg
    const type = msg instanceof Error ? 'error' : notificationConfig?.type
    const newNotification: CustomNotification = {
      ...notificationConfig,
      type: type || 'success',
      msg: message,
      id: ++id,
    }

    setNotifications(old => [...old, newNotification])
  }, [])

  return (
    <NotificationsProvider value={isNotificationsDisabled ? noop : addNotification}>
      {children}
      <ul className={clsx(classes.notificationsContainer, className)}>
        {notifications.map(item => (
          <Notification key={String(item.id)} remove={() => removeNotification(item.id)} {...item} />
        ))}
      </ul>
    </NotificationsProvider>
  )
}
